<!--
 * @Author: chenguanghua
 * @Date: 2022-07-025 16:58:32
 * @LastEditors: zxf
 * @LastEditTime: 2023-08-23 17:14:25
 * @Description: 巡查测试登记
-->
<template>
  <div
    v-loading="loading"
    class="l-page l-page--search"
  >
    <!-- 页面头部 Start -->
    <div
      class="l-page__header c-page__header"
    >
      <!-- 页面标题 -->
      <h2
        v-menu-title
        class="c-page__header-title"
      >
        巡查测试登记
      </h2>

      <!-- 标题栏按钮区域 Start -->
      <div
        class="c-page__header-btns"
      >
        <k-button
          btn-text="查询"
          :auth-type="false"
          type="primary"
          icon="kestrel-icon ki-search"
          @click="refreshSearch()"
        />
        <k-button
          btn-text="重置"
          :auth-type="false"
          icon="kestrel-icon ki-repeat"
          @click="resetForm()"
        />
        <k-button
          btn-text="导出"
          :auth-type="false"
          type="primary"
          icon="kestrel-icon ki-export"
          plain
          :disabled="page.rows.length<1"
          @click="handleExport()"
        />
      </div>
      <!-- 标题栏按钮区域 End -->
    </div>
    <!-- 页面头部 End -->

    <!-- 查询条件 Start -->
    <div
      class="l-page__item l-page--search__item"
    >
      <hm-page-card
        title="查询条件"
        class="c-card--condition"
      >
        <!-- 查询条件表单 Start -->
        <!-- tips：c-condition__form类用于查询类布局的查询条件模块使用 -->
        <el-form
          ref="filterParams"
          class="c-form c-condition__form"
          :model="filterParams"
          :inline="true"
          :rules="filterParamsRules"
          label-position="right"
          label-width="90px"
          label-suffix="："
        >
          <el-row
            class="c-form__row"
          >
            <el-col
              class="c-form__col"
              :span="8"
            >
              <el-form-item
                class="c-form__item"
                label="项目名称"
                prop="xmmc"
              >
                <el-input
                  v-model.trim="filterParams.xmmc"
                  class="c-form__input"
                  placeholder="项目名称"
                  clearable
                  maxlength="100"
                />
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="8"
            >
              <el-form-item
                class="c-form__item"
                label="巡检日期"
                prop="xjrqQz"
              >
                <hm-date-range
                  v-model="filterParams.xjrqQz"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  :clearable="true"
                />
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="8"
            >
              <el-form-item
                class="c-form__item"
                label="登记日期"
                prop="djrqQz"
              >
                <hm-date-range
                  v-model="filterParams.djrqQz"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  :clearable="true"
                />
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="8"
            >
              <el-form-item
                class="c-form__item"
                label="系统设备"
                prop="xtsb"
              >
                <select-sb
                  v-model="filterParams.xtsb"
                  clearable
                  type="wb"
                />
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="8"
            >
              <el-form-item
                class="c-form__item"
                label="类型"
                prop="xclx"
              >
                <el-radio-group
                  v-model="filterParams.xclx"
                  class="c-form__radio-group"
                >
                  <el-radio :label="null">
                    全部
                  </el-radio>
                  <el-radio
                    v-for="item in xccsType"
                    :key="item.id"
                    :label="item.id"
                  >
                    {{ item.text }}
                  </el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="8"
            >
              <el-form-item
                class="c-form__item"
                label="设备状态"
                prop="sbzt"
              >
                <el-radio-group
                  v-model="filterParams.sbzt"
                  class="c-form__radio-group"
                >
                  <el-radio :label="null">
                    全部
                  </el-radio>
                  <el-radio label="Y">
                    正常
                  </el-radio>
                  <el-radio label="N">
                    故障
                  </el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <!-- 查询条件表单 End -->
      </hm-page-card>
    </div>
    <!-- 查询条件 End -->

    <!-- 页面主内容：查询列表 Start -->
    <div
      class="l-page__body l-page--search__body"
    >
      <!-- tips：l-page__tabs--single类用于只有一个tab时修饰页面使用 -->
      <el-tabs
        type="border-card"
        class="l-page__tabs l-page__tabs--single"
      >
        <el-tab-pane
          label="查询结果"
        >
          <!-- table的ref的命名根据业务名称修改 -->
          <k-table
            ref="xccsdjTable"
            height="100%"
            :table-column="tableColumn"
            :data="page.rows"
            :pagination="page"
            @current-change="search"
            @size-change="handleSizeChange"
          >
            <template
              #xmmc="scope"
            >
              <el-link
                type="primary"
                @click="handleDialog('details', { id: scope.row.xcdjId })"
              >
                {{ scope.row.xmmc }}
              </el-link>
            </template>

            <template
              #sbzt="scope"
            >
              <div
                :class="{
                  'u-text-danger': scope.row.sbzt === 'N',
                  'u-text-success': scope.row.sbzt === 'Y'
                }"
              >
                {{ scope.row.sbzt === 'Y' ? '正常' :'故障' }}
              </div>
            </template>
            <el-table-column
              prop="enabled"
              label="操作"
              width="80"
              align="center"
              fixed="right"
            >
              <template
                slot-scope="scope"
              >
                <k-button
                  v-if="scope.row.tsbz !== 'Y'"
                  btn-text="删除"
                  :auth-type="true"
                  type="danger"
                  @click="handleDel(scope.row, scope.$index)"
                />
              </template>
            </el-table-column>
          </k-table>
        </el-tab-pane>
      </el-tabs>
    </div>
    <!-- 页面主内容：查询列表 End -->
    <!-- 查看合同 -->
    <details-dialog
      v-if="showDialogName==='details'"
      :dl-params="dialogParams"
      @closeDialog="handleDialog"
      @callback="refreshSearch()"
    />
  </div>
</template>

<script>
import { xccsdjManageService } from './xccsdj.service.js';
export default {
  name: 'Xccsdj',
  components: {
    detailsDialog: () => import('./detailsDialog')
  },
  data () {
    return {
      loading: false, // 页面是否loading状态
      /* 查询条件（页面绑定的查询条件） start */
      filterParams: {
        xmmc: null, // 项目名称
        xclx: null, // 类型
        xjrqQz: [], // 巡检日期
        xcsjQ: null,
        xcsjZ: null,
        djrqQz: [], // 登记日期
        cjsjQ: null,
        cjsjZ: null,
        xtsb: null,
        xfsbId: null, // 系统设备
        wbnrId: null,
        sbzt: null // 设备状态
      },
      /* 查询条件 end */

      /* 表单校验规则 Start */
      filterParamsRules: {
        xjrqQz: [this.$HMValidator.dateRange('巡检日期')],
        djrqQz: [this.$HMValidator.dateRange('登记日期')]
      },
      /* 表单校验规则 End */

      /* 分页实际查询条件（避免查询条件的双向绑定导致点击分页按钮，获取到的数据不符合真实过滤条件） Start */
      trueFilterParams: {},
      /* 分页实际查询条件 End */

      /* 导出实际查询条件（避免查询条件的双向绑定导致点击导出按钮，获取到的数据与查询结果不一致） Start */
      exportFilterParams: {},
      /* 导出实际查询条件 End */

      /* 查询结果 Start */
      page: {
        rows: [],
        total: 0,
        pageSize: 15,
        pageNo: 0
      },
      /* 查询结果 End */

      /* 表格列配置Start */
      tableColumn: [
        { key: 'index', label: '序号', align: 'center', width: this.$commonConfig.tableWidthConfig.common_xh, type: 'index' },
        { key: 'xmmc', slotName: 'xmmc', label: '项目名称', align: 'left', minWidth: '200', type: 'text' },
        { key: 'wbnrMc', label: '巡检系统', align: 'left', minWidth: '140', type: 'text' },
        { key: 'xfsbMc', label: '巡检设备', align: 'left', minWidth: '140', type: 'text' },
        { key: 'jzwMc', label: '建筑物', align: 'left', width: '100', type: 'text' },
        { key: 'lc', label: '所在楼层', align: 'left', width: '80', type: 'text' },
        { key: 'sbwz', label: '具体位置', align: 'left', minWidth: '120', type: 'text' },
        { key: 'sbzt', slotName: 'sbzt', label: '设备状态', align: 'left', width: '80', type: 'text' },
        { key: 'sbsl', label: '数量', align: 'left', with: '80', type: 'text' },
        { key: 'xclxMc', label: '类型', align: 'left', width: '80', type: 'text' },
        { key: 'xcryMc', label: '操作员', align: 'left', width: '100', type: 'text' },
        { key: 'xcsj', label: '巡检日期', align: 'center', width: '100', type: 'date' },
        { key: 'cjsj', label: '登记日期', align: 'center', width: '100', type: 'date' }

      ],
      /* 表格列配置End */

      /* 弹窗 start */
      showDialogName: '',
      dialogParams: {}
      /* 弹窗 end */

    };
  },
  computed: {
    // 巡查测试类型
    xccsType () {
      const enums = this.$store.state.apiEnums.iffApi;
      if (enums && enums.IFF_ZYLX) {
        return enums.IFF_ZYLX;
      }
      return {};
    }
  },
  methods: {
    /**
     * @description: 记录分页查询条件，调用查询方法
     * @return {*}
     */
    refreshSearch () {
      if (this.$refs.filterParams) {
        this.$refs.filterParams.validate(valid => {
          if (valid) {
            this.trueFilterParams = JSON.parse(JSON.stringify(this.filterParams));
            [this.trueFilterParams.xcsjQ, this.trueFilterParams.xcsjZ] = this.filterParams.xjrqQz;
            [this.trueFilterParams.cjsjQ, this.trueFilterParams.cjsjZ] = this.filterParams.djrqQz;
            this.search();
          }
        });
      } else {
        this.trueFilterParams = JSON.parse(JSON.stringify(this.filterParams));
        [this.trueFilterParams.xcsjQ, this.trueFilterParams.xcsjZ] = this.filterParams.xjrqQz;
        [this.trueFilterParams.cjsjQ, this.trueFilterParams.cjsjZ] = this.filterParams.djrqQz;
        this.search();
      }
    },
    /**
     * @description: 查询列表方法
     * @param {number} _pageNo
     * @return {*}
     */
    search (_pageNo = 1) {
      /* 处理分页参数 Start */
      this.trueFilterParams.pageSize = this.page.pageSize;
      this.trueFilterParams.pageNo = _pageNo;
      /* 处理分页参数 End */
      if (this.filterParams.xtsb != null) {
        [this.trueFilterParams.wbnrId, this.trueFilterParams.xfsbId] = this.filterParams.xtsb.split('/');
      }
      console.log(this.trueFilterParams.xfsbId);
      this.loading = true;

      xccsdjManageService.query(this.trueFilterParams)
        .then(rsp => {
          this.page = Object.assign({}, this.page, rsp.data);

          // 导出条件更新为查询使用的条件
          this.exportFilterParams = JSON.parse(JSON.stringify(this.trueFilterParams));
        })
        .catch(err => {
          console.error('查询错误！', err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    /**
     * @description: 分页切换大小
     * @param {number} val
     * @return {*}
     */
    handleSizeChange (val) {
      this.page.pageSize = val;
      this.search();
    },
    /**
     * @description: 重置页面为初始状态
     * @param：
     * @return {*}
     */
    resetForm () {
      this.$refs.filterParams.resetFields();
    },
    /**
     * @description: 跳转到查看
     * @author: cgh
     */
    handleDialog (_name, _params) {
      this.showDialogName = _name;
      this.dialogParams = _params;
    },
    /**
     * @description: 删除
     * @return {*}
     */
    handleDel (_row) {
      const _this = this;
      _this.$confirm('是否确认删除此巡查测试登记？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        _this.loading = true;
        xccsdjManageService.delete(_row.xcdjId)
          .then(rsp => {
            _this.$alert('删除成功！', '提示', {
              confirmButtonText: '确定',
              type: 'success',
              callback: action => {
              }
            });
            _this.search();
          })
          .catch(err => {
            console.error('删除失败！', err);
          })
          .finally(() => {
            _this.loading = false;
          });
      }).catch(() => {
      });
    },
    /**
     * @description: 导出
     * @param {*}
     * @return {*}
     */
    handleExport () {
      this.loading = true;
      xccsdjManageService.export(this.exportFilterParams)
        .then(rsp => {
          const fileStream = rsp.data;
          const fileName = decodeURIComponent(escape(rsp.headers['content-disposition'].split('=')[1]));
          this.$HMUtil.downloadStreamFile(fileStream, fileName);
        })
        .catch(err => {
          console.error('导出错误！', err);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  created () {
    this.refreshSearch();
  }
};
</script>
